export default __webpack_public_path__ + "static/media/c_1.05461823.jpg";